import React from 'react';
import { motion } from 'framer-motion';
import { Star, MapPin, Trophy, BookOpen } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Cecilia R.',
    location: 'Mendoza',
    pack: 'PackViajero Expert',
    packIcon: <Trophy className="w-3 h-3" data-id="element-334" />,
    quote: 'El Tomo de anti-estafas me salvó en Covent Garden. Reconocí la estafa de la pulsera y seguí caminando sin ni mirarlos. Todo exactamente como decía.'
  }, {
    name: 'Roberto M.',
    location: 'Buenos Aires',
    pack: 'PackViajero Completo',
    packIcon: <BookOpen className="w-3 h-3" data-id="element-335" />,
    quote: 'Con la guía de frases del Bono 2 pude pedir en el pub, reclamar en el hotel y hasta hacer una denuncia por un cargo incorrecto. Sin esto no sé qué hubiera hecho.'
  }, {
    name: 'Sofía C.',
    location: 'La Plata',
    pack: 'PackViajero Expert',
    packIcon: <Trophy className="w-3 h-3" data-id="element-336" />,
    quote: 'El itinerario de 5 días del Expert me ahorró al menos £300. Comí increíble, hice los mejores recorridos y no pagué ni una sola entrada carísima.'
  }, {
    name: 'Pablo A.',
    location: 'Neuquén',
    pack: 'PackViajero Completo',
    packIcon: <BookOpen className="w-3 h-3" data-id="element-337" />,
    quote: 'Lo leí en el avión y llegué sabiendo exactamente qué hacer. El protocolo del pasaporte perdido me quedó grabado. Por suerte no lo necesité, pero saber que estaba preparado me cambió el viaje.'
  }];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-slate-900/50" data-id="element-338">
      <div className="max-w-6xl mx-auto" data-id="element-339">
        <div className="text-center mb-16" data-id="element-340">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 flex items-center justify-center gap-3" data-id="element-341">
            <span className="text-red-500" data-id="element-342">❤️</span> Más viajeros que ya lo
            usaron
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-343">
          {testimonials.map((test, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="glass-panel p-8 rounded-2xl relative" data-id="element-344">
              <div className="flex gap-1 mb-4" data-id="element-345">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-5 h-5 fill-amber-400 text-amber-400" data-id="element-346" />)}
              </div>
              <p className="text-slate-300 text-lg italic mb-6 leading-relaxed" data-id="element-347">
                "{test.quote}"
              </p>

              <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 pt-4 border-t border-slate-700/50" data-id="element-348">
                <div data-id="element-349">
                  <div className="font-bold text-white text-lg" data-id="element-350">
                    {test.name}
                  </div>
                  <div className="flex items-center gap-1 text-sm text-slate-400" data-id="element-351">
                    <MapPin className="w-3 h-3" data-id="element-352" /> {test.location}
                  </div>
                </div>
                <div className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-bold ${test.pack.includes('Expert') ? 'bg-amber-500/20 text-amber-400 border border-amber-500/30' : 'bg-blue-500/20 text-blue-400 border border-blue-500/30'}`} data-id="element-353">
                  {test.packIcon} {test.pack}
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}